import './App.css';
import React,{useState,useRef} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import Lottie from "lottie-react";
import Welcome from "./assets/welcome.json"
// import LinkedinIcon from "@mui/material/Icon/I"


const firebaseConfig = {
  apiKey: "AIzaSyA7iSkSpoyKd7UZ8wy70lExZ1r1HGeVvl4",
  authDomain: "spark-c4660.firebaseapp.com",
  projectId: "spark-c4660",
  storageBucket: "spark-c4660.appspot.com",
  messagingSenderId: "845397401089",
  appId: "1:845397401089:web:1dae675ade57581b16aa00",
  measurementId: "G-3Q9D4T86NF"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {
  const [user] = useAuthState(auth);
  return (
    <>
    <div className='App' >
      <header>
        <h1 style={{ fontVariant:'small-caps', fontWeight:'600', letterSpacing:2, textShadow:'1px 1px 5px #370898'}} >Spark Chat App</h1>
        <SignOut />
      </header>
      <section>
      {user ? "" : <Lottie animationData={Welcome} loop={true} style={{width:"60%",alignSelf:"center"}} />}
      {user ? <ChatRoom /> : <SignIn />}

      </section>
       
    </div>
    
   </>
  );
}

function SignIn() {

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }

  return (
    <>
      <button className="sign-in" style={{borderRadius:25}} onClick={signInWithGoogle}>Sign in with Google</button>
      <p style={{alignSelf:"center"}} >Developed by <b>Hardik Panwar</b> <br/>Copyright @2023  </p>
    </>
  )

}

function SignOut() {
  return auth.currentUser && (
    <button className="sign-out" style={{backgroundColor:"#F5EBEB",color:"black",borderRadius:30}} onClick={() => auth.signOut()}>Sign Out</button>
  )
}


function ChatRoom() {
  const dummy = useRef();
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(25);

  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');


  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL
    })

    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (<>
    <main>

      {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}

      <span ref={dummy}></span>

    </main>

    <form onSubmit={sendMessage} style={{height:"70px"}} >

      <input style={{}} value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="Message..." />

      <button type="submit" disabled={!formValue}>Send</button>

    </form>
  </>)
}


function ChatMessage(props) {
  const { text, uid, photoURL } = props.message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  return (<>
    <div className={`message ${messageClass}`}>
      <img src={photoURL || 'https://api.dicebear.com/5.x/avataaars/svg?seed=Buster'} />
      <p>{text}</p>
    </div>
  </>)
}

export default App;
